import { useEffect, useState } from 'react';

const TICK_MS = 1000;

let clock = Date.now();
const listeners = new Set();
let timer = null;

function startClock() {
  if (timer) return;
  timer = setInterval(() => {
    clock = Date.now();
    listeners.forEach((listener) => listener(clock));
  }, TICK_MS);
}

function stopClock() {
  if (listeners.size || !timer) return;
  clearInterval(timer);
  timer = null;
}

/**
 * Shared 1s clock for live Work timers. Multiple headers / step rows
 * subscribe to one interval instead of each running setInterval.
 */
export function useWorkNow(enabled) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!enabled) return undefined;
    setNow(Date.now());
    listeners.add(setNow);
    startClock();
    return () => {
      listeners.delete(setNow);
      stopClock();
    };
  }, [enabled]);

  return enabled ? now : clock;
}
